export default function encodeForUrl (text) {
    if (!text) return 'brak'
    return encodeURIComponent(text)
}